import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';

import { SharedModule } from '@blaze-shared/shared-feature';
import { DialogComponent } from '@blaze-shared/shared-ui';

interface DuplicateBlazeTableDialogResult {
  name: string;
  copyData: boolean;
}

@Component({
  selector: 'blaze-table-duplicate-dialog',
  templateUrl: './blaze-table-duplicate-dialog.component.html',
  styleUrls: ['./blaze-table-duplicate-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRadioModule, MatIconModule, DialogComponent, SharedModule],
})
export class DuplicateBlazeTableDialogComponent {
  private dialogRef =
    inject<MatDialogRef<DuplicateBlazeTableDialogComponent, DuplicateBlazeTableDialogResult>>(
      MatDialogRef,
    );

  dialogData = inject(MAT_DIALOG_DATA);

  tableName: FormControl<string | null>;
  copyData = false;

  constructor() {
    this.tableName = new FormControl();
  }

  linkConditionChanged(event: MatRadioChange): void {
    this.copyData = event.value;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close({
      name: this.tableName.value || this.dialogData,
      copyData: this.copyData,
    });
  }
}
